// AUTO-GENERATED by scripts/gen-build-info.js — do not edit by hand.
export const BUILD_INFO = {
  commit: "4fe24d5",
  branch: "HEAD",
  buildTime: "2026-11-05T16:08:50.485Z",
} as const;
